// 订单状态
export const orderType = function (status) {
  let statusText = '';
  switch (status) {
    case 1:
      statusText = '审核中';
      break;
    case 2:
      statusText = '待退款'; // 退差价
      break;
    case 3:
      // statusText = '待补款'; 应补差价
      statusText = '待支付';
      break;
    case 5:
      statusText = '已关闭';
      break;
    case 6:
      statusText = '被打回';
      break;
    case 7:
      statusText = '已撤销';
      break;
    case 8:
      statusText = '超时未付款';
      break;
    case 9:
      statusText = '自动退款失败';
      break;
    default:
      statusText = '已完成';
      break;
  }
  return statusText;
};
// 订单支付类型
export const paymentType = function (status) {
  let statusText = '';
  switch (status) {
    case 1:
      statusText = '支付宝支付';
      break;
    case 2:
      statusText = '微信支付';
      break;
    case 3:
      statusText = '余额支付';
      break;
    case 6:
      statusText = '花呗支付';
      break;
    case 9:
      statusText = '白条分期';
      break;
    default:
  }
  return statusText;
};
// 退款方式类型
export const refundAmountType = function (status) {
  let statusText = '';
  switch (status) {
    case 0:
      statusText = '原路退回';
      break;
    case 1:
      statusText = '余额';
      break;
    default:
  }
  return statusText;
};
// 换课售后类型 1 退差换货 2 补差换货 3 无差额换货
export const rechangeType = function (status) {
  let statusText = '';
  switch (status) {
    case 1:
      statusText = '退差换货';
      break;
    case 2:
      statusText = '补差换货';
      break;
    case 3:
      statusText = '无差额换货';
      break;
    default:
  }
  return statusText;
};
